import { useEffect, useRef } from 'react';
import {
	NEWRELIC_ACCOUNT_ID,
	NEWRELIC_APPLICATION_ID,
	NEWRELIC_BEACON,
	NEWRELIC_LICENSE_KEY,
	NEWRELIC_MONITORING_ENABLED
} from '../constants';

export const useInitializeNewRelic = (): void => {
	const isInitialized = useRef(false);

	useEffect(() => {
		if (isInitialized.current || !NEWRELIC_MONITORING_ENABLED) {
			return;
		}

		const options = {
			info: {
				beacon: NEWRELIC_BEACON,
				errorBeacon: NEWRELIC_BEACON,
				licenseKey: NEWRELIC_LICENSE_KEY,
				applicationID: NEWRELIC_APPLICATION_ID,
				sa: 1
			},
			loader_config: {
				accountID: NEWRELIC_ACCOUNT_ID,
				trustKey: NEWRELIC_ACCOUNT_ID,
				agentID: NEWRELIC_APPLICATION_ID,
				licenseKey: NEWRELIC_LICENSE_KEY,
				applicationID: NEWRELIC_APPLICATION_ID
			},
			init: {
				distributed_tracing: { enabled: true },
				privacy: { cookies_enabled: true },
				ajax: { deny_list: [NEWRELIC_BEACON, 'b.clarity.ms', 'www.google-analytics.com'] }
			}
		};

		import('@newrelic/browser-agent/loaders/browser-agent')
			.then(agentModule => {
			new agentModule.BrowserAgent(options);

			console.info('NewRelic browser agent initialized');
		}).catch(e => {
			console.error('NewRelic init failed', e);
		});

		isInitialized.current = true;
	}, []);
}
